var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.75,
    height: 32.833,
    viewBox: "0 0 29.75 32.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(-3.625 -2.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10566",
    "data-name": "Path 10566",
    d: "M12.333,18.808H23.125",
    fill: "none",
    stroke: "#fd792f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10567",
    "data-name": "Path 10567",
    d: "M12.333,24.975h6.753",
    fill: "none",
    stroke: "#fd792f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10568",
    "data-name": "Path 10568",
    d: "M15.417,9.25h6.167c3.083,0,3.083-1.542,3.083-3.083,0-3.083-1.542-3.083-3.083-3.083H15.417c-1.542,0-3.083,0-3.083,3.083S13.875,9.25,15.417,9.25Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569",
    "data-name": "Path 10569",
    d: "M24.667,6.2c5.134.278,7.708,2.174,7.708,9.219v9.25c0,6.167-1.542,9.25-9.25,9.25h-9.25c-7.708,0-9.25-3.083-9.25-9.25v-9.25c0-7.03,2.575-8.942,7.708-9.219",
    fill: "none",
    stroke: "#fd792f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.82e79e04fd6a55e0b43729123b921da9.svg";
export { ForwardRef as ReactComponent };